import { apiBaseKeys } from 'core/api/api.routes';
import { updateQuery } from 'core/api/query.config';
import { usePocMutation } from 'core/custom-hooks/usePocMutation';
import { saveLanguage } from './api/api';

export const useSaveLanguage = () => {
  const mutation = usePocMutation({
    mutationFn: saveLanguage,
    onSuccess: () => void updateQuery([apiBaseKeys.settings]),
  });

  return {
    saveLanguage: mutation.mutate,
    isSavingLanguage: mutation.isPending,
    isSaveLanguageError: mutation.isError,
  };
};
